import type { GlAccount } from "../../../../hooks/useGLAccounts";

export type { GlAccount };

export enum GlaFilterPreset {
    ALL = "all",
    PROFIT_AND_LOSS = "profit_and_loss",
    BALANCE_SHEET = "balance_sheet",
    FIXED_ASSETS_BS = "fixed_assets_bs",
    FIXED_ASSETS_PL = "fixed_assets_pl",
}

export enum GlaAccountType {
    UNCATEGORIZED = "uncategorized",
    BALANCE_SHEET = "balance_sheet",
    PROFIT_AND_LOSS = "profit_and_loss",
}

export interface GlaGroupedAccounts {
    type: GlaAccountType;
    label: string;
    accounts: GlAccount[];
}
